
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("3xzAj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "EmptySkeleton", () => $f444c4a4f006245a$export$fb85bbdbfb3e6869);
$parcel$export(module.exports, "GinRedirect", () => $f444c4a4f006245a$export$3b4f172f4310bbc);
$parcel$export(module.exports, "GinRedirectEntryPoint", () => $f444c4a4f006245a$export$259dd4583d348d86);
$parcel$export(module.exports, "default", () => $f444c4a4f006245a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $1GQw6 = parcelRequire("1GQw6");

var $dV4qk = parcelRequire("dV4qk");

var $9RQJa = parcelRequire("9RQJa");

var $eznTg = parcelRequire("eznTg");

var $kh7bJ = parcelRequire("kh7bJ");

var $4EKqI = parcelRequire("4EKqI");

var $5vQ2T = parcelRequire("5vQ2T");

var $2dBpR = parcelRequire("2dBpR");

var $4cTDP = parcelRequire("4cTDP");

var $3So8J = parcelRequire("3So8J");
const $f444c4a4f006245a$export$fb85bbdbfb3e6869 = ()=>null;
const $f444c4a4f006245a$var$GlobalIssueNavigatorEntryPointContainer = /*#__PURE__*/ (0, $eJOHy.memo)(({ entryPointReference: entryPointReference, nativeIssueTableEntryPoint: nativeIssueTableEntryPoint, jqlBuilderWithAiEntryPoint: jqlBuilderWithAiEntryPoint })=>{
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            preloadedEntryPoints: {
                nativeIssueTableEntryPoint: nativeIssueTableEntryPoint,
                ...(0, $4cTDP.fg)('jql_builder_basic_ssr_stability_fixes') && {
                    jqlBuilderWithAiEntryPoint: jqlBuilderWithAiEntryPoint
                }
            }
        }), [
        nativeIssueTableEntryPoint,
        jqlBuilderWithAiEntryPoint
    ]);
    const ErrorBoundary = (0, $4cTDP.fg)('improve_nin_slo_events') ? (0, $3So8J.default) : (0, $5vQ2T.JSErrorBoundary);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "jira-router-gin-redirect-entrypoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ErrorBoundary, {
        id: "jira-router-gin-redirect-entrypoint",
        packageName: "jiraRouterIssueNavigatorEntries"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
        name: "gin-redirect-entrypoint",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f444c4a4f006245a$export$fb85bbdbfb3e6869, null),
        entryPointReference: entryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: entryPointReference,
        // EntryPointContainer can't infer the type of props from entryPointReference correctly
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: entryPointProps
    }))));
});
const $f444c4a4f006245a$export$3b4f172f4310bbc = ({ preloadedEntryPoints: preloadedEntryPoints })=>{
    const [isNinGlobalScopeEnrolmentEnabled, resourceData] = (0, $1GQw6.useGlobalScopeEnrolmentEnable)();
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    // Regardless of the existing localStorageData value, we update the localStorage value once we get resourceData so
    // that future renders are fast and accurate.
    (0, $eJOHy.useEffect)(()=>{
        if (resourceData !== null && resourceData !== undefined) (0, $dV4qk.setIsGlobalScopeEnrolmentEnabledInLocalStorage)(resourceData);
    }, [
        resourceData
    ]);
    // If NIN in global scope is not enabled then we redirect to legacy GIN by performing a reload
    (0, $eJOHy.useEffect)(()=>{
        if (isNinGlobalScopeEnrolmentEnabled === false) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    }, [
        isNinGlobalScopeEnrolmentEnabled
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isNinGlobalScopeEnrolmentEnabled) {
            // If we are in global scope nin then reset/enable the forced opt out flag for GIN if we haven't done it already
            const globalGINFlagDisabled = (0, $dV4qk.getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage)();
            if (globalGINFlagDisabled !== false) {
                !isAnonymous && (0, $9RQJa.resetGlobalScopeForcedOptOutGinFlag)();
                (0, $dV4qk.setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage)();
            }
        }
    }, [
        isAnonymous,
        isNinGlobalScopeEnrolmentEnabled
    ]);
    const entryPointReference = preloadedEntryPoints.globalIssueNavigatorEntryPoint;
    const nativeIssueTableEntryPoint = preloadedEntryPoints.nativeIssueTableEntryPoint;
    const jqlBuilderWithAiEntryPoint = preloadedEntryPoints.jqlBuilderWithAiEntryPoint;
    // If NIN in global scope is enabled then we render it. If NIN in global scope is not enabled, or we're blocked
    // waiting on the resource to load then we render GlobalIssueNavigatorSkeleton.
    return isNinGlobalScopeEnrolmentEnabled === true && entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f444c4a4f006245a$var$GlobalIssueNavigatorEntryPointContainer, {
        entryPointReference: entryPointReference,
        nativeIssueTableEntryPoint: nativeIssueTableEntryPoint,
        jqlBuilderWithAiEntryPoint: jqlBuilderWithAiEntryPoint
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eznTg.GlobalIssueNavigatorSkeleton), null);
};
const $f444c4a4f006245a$export$259dd4583d348d86 = ({ entryPoints: entryPoints })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f444c4a4f006245a$export$3b4f172f4310bbc, {
        preloadedEntryPoints: entryPoints
    });
var $f444c4a4f006245a$export$2e2bcd8739ae039 = $f444c4a4f006245a$export$259dd4583d348d86;

});
parcelRegister("1GQw6", function(module, exports) {
$parcel$export(module.exports, "useGlobalScopeOptOutFlow", () => $637c291c7d03f593$export$f39dd0211cb78bcf);
$parcel$export(module.exports, "useGlobalScopeEnrolmentEnable", () => $637c291c7d03f593$export$f45d1a4e873cac44);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $cxKOj = parcelRequire("cxKOj");

var $cSXp8 = parcelRequire("cSXp8");

var $dV4qk = parcelRequire("dV4qk");

var $9RQJa = parcelRequire("9RQJa");

var $dSkEC = parcelRequire("dSkEC");

var $3lhVL = parcelRequire("3lhVL");

var $kh7bJ = parcelRequire("kh7bJ");

var $eJrcF = parcelRequire("eJrcF");

var $8tIrO = parcelRequire("8tIrO");

var $4cTDP = parcelRequire("4cTDP");

var $1YCwi = parcelRequire("1YCwi");

var $2R6bM = parcelRequire("2R6bM");
const $637c291c7d03f593$var$sessionStorageProvider = (0, $8tIrO.createSessionStorageProvider)('', false);
const $637c291c7d03f593$export$f39dd0211cb78bcf = (href)=>{
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const redirectToGin = (0, $eJOHy.useCallback)(()=>{
        if (href) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.assign(href);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    }, [
        href
    ]);
    const { renderFeedbackDialog: renderFeedbackDialog } = (0, $1YCwi.default)({
        onClose: redirectToGin,
        isAdminSettingsModal: false
    });
    /**
	 * globalScopeOptOut
	 * Triggers the NIN Global Scope opt-out process, including all UI orchestration of feedback.
	 *
	 * The caller should handle "default" behaviour for when the user is already not enrolled,
	 * unless the `preventDefault` callback has been called. This allows for easy usage with links,
	 * where the onClick event's `preventDefault` can be passed.
	 *
	 * If using an event's `preventDefault`, remember to bind the event!
	 * ex: `globalScopeOptOut(event.preventDefault.bind(event));`
	 *
	 * @param {Function} preventDefault
	 */ return (0, $eJOHy.useCallback)(async (preventDefault)=>{
        // If the user has already opt-out, just allow the caller to handle the click
        if (!(0, $dV4qk.getIsGlobalScopeEnrolmentEnabledFromLocalStorage)()) return;
        // Otherwise, take over the interaction
        preventDefault && preventDefault();
        try {
            // Update user preference and local storage
            !isAnonymous && await (0, $9RQJa.setIsGlobalScopeEnrolmentEnabledUserPreference)(false);
            (0, $dV4qk.setIsGlobalScopeEnrolmentEnabledInLocalStorage)(false);
            renderFeedbackDialog();
            if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) $637c291c7d03f593$var$sessionStorageProvider.set('showGinOptOutFlag', 'true');
            else sessionStorage.setItem('showGinOptOutFlag', 'true');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            showFlag({
                type: 'error',
                title: (0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2R6bM.default).errorOptOutTitleIssueTermRefresh : (0, $2R6bM.default).errorOptOutTitle,
                description: (0, $2R6bM.default).errorOptOutDesc,
                testId: 'issue-navigator-action-meatball-menu.ui.error-flag',
                messageId: 'issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.show-flag.error',
                messageType: 'transactional'
            });
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'optOutOfNin',
                    packageName: 'jiraIssueNavigatorChangeboarding',
                    teamName: 'empanada'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
        }
    }, [
        isAnonymous,
        renderFeedbackDialog,
        showFlag
    ]);
};
const $637c291c7d03f593$export$f45d1a4e873cac44 = ()=>{
    // We store localStorageData as state so that it's not recalculated during subsequent renders. We want that as a
    // guarantee, not just as a performance optimisation, so we're using useState rather than useMemo.
    //
    // The reason we want to guarantee it's only fetched during the initial render is that we want
    // isNinGlobalScopeEnrolmentEnabled to be stable if there's localStorageData. This can prevent a bug where fetch
    // true from localStorage, we render NIN, the resource returns false, we update local storage to false, and then
    // GinRedirect is rendered again by a parent component and localStorage now returns false and we redirect later
    // than we should.
    const [localStorageData] = (0, $eJOHy.useState)((0, $dV4qk.getIsGlobalScopeEnrolmentEnabledFromLocalStorage));
    const { data: resourceData } = (0, $eJrcF.useResource)((0, $dSkEC.isNinGlobalScopeEnrolmentEnabledResource));
    const [{ isInitialRender: isInitialRender }] = (0, $3lhVL.useSpaStateTransition)();
    if ((0, $4cTDP.fg)('nin_remove_global_scope_enrolment')) return [
        true,
        true
    ];
    // We assume NIN global scope is enabled if this is an initial render, otherwise we rely on localStorageData if it
    // exists, otherwise we use resourceData. resourceData is async, and can block for a long time, so we optimise for
    // speed rather than correctness by trusting localStorageData.
    let isNinGlobalScopeEnrolmentEnabled;
    if (isInitialRender) isNinGlobalScopeEnrolmentEnabled = true;
    else if (localStorageData !== null && localStorageData !== undefined) isNinGlobalScopeEnrolmentEnabled = localStorageData;
    else isNinGlobalScopeEnrolmentEnabled = resourceData;
    return [
        isNinGlobalScopeEnrolmentEnabled,
        resourceData
    ];
};

});
parcelRegister("dV4qk", function(module, exports) {
$parcel$export(module.exports, "getIsGlobalScopeEnrolmentEnabledFromLocalStorage", () => $0a39e098f20828aa$export$55632339cd4dae9c);
$parcel$export(module.exports, "getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage", () => $0a39e098f20828aa$export$7b78bfe0a111cecf);
$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledInLocalStorage", () => $0a39e098f20828aa$export$82b2633cf7498c5e);
$parcel$export(module.exports, "setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage", () => $0a39e098f20828aa$export$458eda2352a1e223);

var $3hRxq = parcelRequire("3hRxq");

var $eSnSE = parcelRequire("eSnSE");
const $0a39e098f20828aa$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY = 'jira.nin.global.scope.enrolment';
const $0a39e098f20828aa$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY = 'jira.user.nin.global.scope.enrolment.flag.disabled';
const $0a39e098f20828aa$var$ninGlobalScopeEnrolmentLocalStorage = (0, $3hRxq.createLocalStorageProvider)('nin-changeboarding');
const $0a39e098f20828aa$export$34434fbbe40a8047 = ()=>$0a39e098f20828aa$var$ninGlobalScopeEnrolmentLocalStorage.remove($0a39e098f20828aa$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $0a39e098f20828aa$export$55632339cd4dae9c = ()=>$0a39e098f20828aa$var$ninGlobalScopeEnrolmentLocalStorage.get($0a39e098f20828aa$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $0a39e098f20828aa$export$7b78bfe0a111cecf = ()=>$0a39e098f20828aa$var$ninGlobalScopeEnrolmentLocalStorage.get($0a39e098f20828aa$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY);
const $0a39e098f20828aa$export$82b2633cf7498c5e = (isNINEnrolmentEnabled)=>{
    // In practice this is very unlikely to fail, as our local storage library checks that local storage is working
    // during initialisation. However in order to be robust we will catch any errors and recover by simply deleting the
    // existing local storage value (it's just a cache, so deleting it and delegating to the server will work fine)
    try {
        $0a39e098f20828aa$var$ninGlobalScopeEnrolmentLocalStorage.set($0a39e098f20828aa$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY, isNINEnrolmentEnabled);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $eSnSE.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage value, removing instead');
        $0a39e098f20828aa$export$34434fbbe40a8047();
    }
};
const $0a39e098f20828aa$export$458eda2352a1e223 = ()=>{
    try {
        $0a39e098f20828aa$var$ninGlobalScopeEnrolmentLocalStorage.set($0a39e098f20828aa$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY, false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $eSnSE.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage flag value');
    }
};

});

parcelRegister("9RQJa", function(module, exports) {
$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledUserPreference", () => $60e9991f4776398c$export$2fc59b10f256dbee);
$parcel$export(module.exports, "resetGlobalScopeForcedOptOutGinFlag", () => $60e9991f4776398c$export$89f09c81b642e3c7);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");
const $60e9991f4776398c$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION = `
    mutation SetGlobalScopeUserPreferenceMutation($input: SetMyPreferenceInput!) {
        setMyPreference(input: $input) {
            success
        }
    }
`;
const $60e9991f4776398c$var$setGlobalScopeUserPreference = async (input)=>{
    const result = await (0, $3ugTQ.performPostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $60e9991f4776398c$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION,
            variables: {
                input: input
            }
        })
    });
    if (result.data.setMyPreference.success !== true) throw new Error(`Error setting user preference: ${input.key}`, {
        cause: result.errors?.[0]
    });
};
const $60e9991f4776398c$export$2fc59b10f256dbee = async (value)=>$60e9991f4776398c$var$setGlobalScopeUserPreference({
        key: 'jira.user.nin.global.scope.enrolment',
        value: value ? 'nin' : 'gin'
    });
const $60e9991f4776398c$export$89f09c81b642e3c7 = async ()=>$60e9991f4776398c$var$setGlobalScopeUserPreference({
        key: 'jira.user.nin.global.scope.enrolment.flag.disabled',
        value: false
    }).catch((error)=>(0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'resetGlobalScopeGinFlag',
                packageName: 'jiraIssueNavigatorGlobalScopeEnrolment',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        }));

});

parcelRegister("1YCwi", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1c412d8554050b7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $cxKOj = parcelRequire("cxKOj");

var $gdeTc = parcelRequire("gdeTc");

var $4Qvpr = parcelRequire("4Qvpr");

var $lRq8t = parcelRequire("lRq8t");

var $hih5V = parcelRequire("hih5V");

var $kkHo2 = parcelRequire("kkHo2");

var $6nVJI = parcelRequire("6nVJI");

var $koAZ4 = parcelRequire("koAZ4");

var $1F4ru = parcelRequire("1F4ru");
const $e1c412d8554050b7$export$3fe286306fb8ddfb = 'global-scope-issue-navigator-opt-out';
const $e1c412d8554050b7$var$unknownAttributeValue = 'unknown';
const $e1c412d8554050b7$export$b028e515f8f652e0 = ({ isSiteAdmin: isSiteAdmin, routeName: routeName, routeGroup: routeGroup, projectType: projectType, isProjectSimplified: isProjectSimplified, cloudId: cloudId })=>[
        {
            id: (0, $gdeTc.EntryKeys).LOCATION,
            value: (0, $kkHo2.default)(globalThis.location?.href)
        },
        {
            id: (0, $gdeTc.EntryKeys).REFERER,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            value: document.referrer ? (0, $kkHo2.default)(document.referrer) : ''
        },
        {
            id: (0, $gdeTc.EntryKeys).USER_AGENT,
            value: globalThis.navigator?.userAgent
        },
        {
            id: (0, $gdeTc.EntryKeys).SCREEN_RESOLUTION,
            value: `${globalThis.window?.screen?.width} x ${globalThis.window?.screen?.height}`
        },
        {
            id: (0, $gdeTc.EntryKeys).ROUTE_NAME,
            value: routeName
        },
        {
            id: (0, $gdeTc.EntryKeys).ROUTE_GROUP,
            value: routeGroup
        },
        {
            id: (0, $gdeTc.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: isProjectSimplified.toString()
        },
        {
            id: (0, $gdeTc.EntryKeys).IS_ADMIN,
            value: isSiteAdmin.toString()
        },
        {
            id: (0, $gdeTc.EntryKeys).PROJECT_TYPE,
            value: projectType
        },
        {
            id: 'cloud-id',
            value: cloudId
        }
    ];
const $e1c412d8554050b7$export$3a73a4e2115ebf73 = ({ isAdminSettingsModal: isAdminSettingsModal = false })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const titleDetails = isAdminSettingsModal ? formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1F4ru.default).titleDetailsAdminIssueTermRefresh : (0, $1F4ru.default).titleDetailsAdmin) : formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1F4ru.default).titleDetailsUserIssueTermRefresh : (0, $1F4ru.default).titleDetailsUser);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $e1c412d8554050b7$var$feedbackTitleDetailsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "p"
    }, titleDetails));
};
const $e1c412d8554050b7$var$useFeedbackDialog = ({ isAdminSettingsModal: isAdminSettingsModal = false, onClose: onClose = ()=>undefined })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $4Qvpr.useFeedbackCollectorActions)();
    const route = (0, $hih5V.useCurrentRoute)();
    const [{ data: projectData }] = (0, $6nVJI.useContainerContext)();
    const { cloudId: cloudId, isSiteAdmin: isSiteAdmin } = (0, $koAZ4.useTenantContext)();
    const routeGroup = route.group ?? $e1c412d8554050b7$var$unknownAttributeValue;
    const routeName = route.name ?? $e1c412d8554050b7$var$unknownAttributeValue;
    let projectType = $e1c412d8554050b7$var$unknownAttributeValue;
    let isProjectSimplified = false;
    if (projectData && 'project' in projectData && projectData.project) {
        projectType = projectData.project.type;
        isProjectSimplified = projectData.project.isSimplified;
    }
    const renderFeedbackDialog = (0, $eJOHy.useCallback)(()=>{
        openFeedbackCollector({
            feedbackGroupId: $e1c412d8554050b7$export$3fe286306fb8ddfb,
            entrypointId: (0, $gdeTc.ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR),
            onClose: onClose,
            feedbackContext: $e1c412d8554050b7$export$b028e515f8f652e0({
                isSiteAdmin: isSiteAdmin,
                cloudId: cloudId,
                routeGroup: routeGroup,
                routeName: routeName,
                projectType: projectType,
                isProjectSimplified: isProjectSimplified
            }),
            feedbackTitle: formatMessage((0, $1F4ru.default).title),
            feedbackTitleDetails: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e1c412d8554050b7$export$3a73a4e2115ebf73, {
                isAdminSettingsModal: isAdminSettingsModal
            }),
            selectLabel: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1F4ru.default).reasonTitleIssueTermRefresh : (0, $1F4ru.default).reasonTitle),
            // Intentional whitespace to clear the placeholder
            // (eluding feedback dialog's empty check for this prop, which includes empty string)
            summaryPlaceholder: ' ',
            submitButtonLabel: formatMessage((0, $1F4ru.default).submitCaption),
            cancelButtonLabel: formatMessage((0, $1F4ru.default).cancelCaption),
            feedbackGroupLabels: {
                empty: {
                    selectOptionLabel: formatMessage((0, $1F4ru.default).reasonPlaceholder)
                },
                bug: {
                    fieldLabel: formatMessage((0, $1F4ru.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $1F4ru.default).reasonBug)
                },
                comment: {
                    fieldLabel: formatMessage((0, $1F4ru.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $1F4ru.default).reasonSpeed)
                },
                suggestion: {
                    fieldLabel: formatMessage((0, $1F4ru.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $1F4ru.default).reasonOthers)
                },
                question: {
                    fieldLabel: formatMessage((0, $1F4ru.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $1F4ru.default).reasonParity)
                }
            }
        });
    }, [
        openFeedbackCollector,
        onClose,
        isSiteAdmin,
        cloudId,
        routeGroup,
        routeName,
        projectType,
        isProjectSimplified,
        formatMessage,
        isAdminSettingsModal
    ]);
    return {
        renderFeedbackDialog: renderFeedbackDialog
    };
};
var $e1c412d8554050b7$export$2e2bcd8739ae039 = $e1c412d8554050b7$var$useFeedbackDialog;
const $e1c412d8554050b7$var$feedbackTitleDetailsContainerStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.050'
});

});
parcelRegister("1F4ru", function(module, exports) {
$parcel$export(module.exports, "default", () => $80babb5252f619a3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $80babb5252f619a3$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title",
        "defaultMessage": "Let us know why you're moving"
    },
    titleDetailsAdmin: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-admin",
        "defaultMessage": "You and your users will be able to use the old issue search temporarily."
    },
    titleDetailsUser: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-user",
        "defaultMessage": "You'll be able to use the old issue search temporarily."
    },
    submitCaption: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.submit-caption",
        "defaultMessage": "Send feedback"
    },
    cancelCaption: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.cancel-caption",
        "defaultMessage": "Skip"
    },
    reasonTitle: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-title",
        "defaultMessage": "What is your reason to go back to the old issue search?"
    },
    reasonPlaceholder: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-placeholder",
        "defaultMessage": "Select an option"
    },
    reasonParity: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-parity",
        "defaultMessage": "Features are missing"
    },
    reasonSpeed: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-speed",
        "defaultMessage": "It's slow"
    },
    reasonBug: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-bug",
        "defaultMessage": "There's a bug"
    },
    reasonOthers: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-others",
        "defaultMessage": "Others"
    },
    reasonQuestion: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-question",
        "defaultMessage": "Can you provide more details? It'll help make search better for everyone."
    },
    titleDetailsAdminIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-admin-issue-term-refresh",
        "defaultMessage": "You'll be able to use the old way to search for work items temporarily."
    },
    titleDetailsUserIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-user-issue-term-refresh",
        "defaultMessage": "You'll be able to use the old way to search for work items temporarily."
    },
    reasonTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-title-issue-term-refresh",
        "defaultMessage": "What's the reason you're going back to the old way to searching for work items?"
    }
});
var $80babb5252f619a3$export$2e2bcd8739ae039 = $80babb5252f619a3$var$messages;

});


parcelRegister("2R6bM", function(module, exports) {
$parcel$export(module.exports, "default", () => $d19b60e1630b22b1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d19b60e1630b22b1$var$messages = (0, $7qGN1.defineMessages)({
    errorOptOutTitle: {
        "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-title",
        "defaultMessage": "We couldn't switch to the old issue search"
    },
    errorOptOutDesc: {
        "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-desc",
        "defaultMessage": "Refresh and try again."
    },
    errorOptOutTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-title-issue-term-refresh",
        "defaultMessage": "We couldn't switch to the old search"
    }
});
var $d19b60e1630b22b1$export$2e2bcd8739ae039 = $d19b60e1630b22b1$var$messages;

});




//# sourceMappingURL=async-global-issue-navigator-gin-redirect-entrypoint.5fc68fa2.js.map
